import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { NeuInput } from "../../components/neu/Neu";
import { fmtMoney } from "../../lib/format";

const num = (v) => { const n = parseFloat(v); return isFinite(n) ? n : 0; };
const fix = (v) => (isFinite(v) ? v.toFixed(2) : "");

// كارت الإجماليات مع خصم/ضريبة اتجاهيَّيْن + تنبيه عند تعديل نسبة الضريبة عن الافتراضي.
export const PurchaseTotals = ({ totals, head, onChange, currency = "AED" }) => {
  const { t } = useTranslation();
  const defPct = head.tax_default_pct;
  const overridden = defPct != null && head.tax_percent !== "" && head.tax_percent != null
    && Math.abs(num(head.tax_percent) - num(defPct)) > 0.01;

  const setDiscPct = (e) => {
    const pct = e.target.value;
    const amt = totals.subtotal > 0 && pct !== "" ? fix((num(pct) * totals.subtotal) / 100) : "";
    onChange({ ...head, discount_percent: pct, discount_amount: amt });
  };
  const setDiscAmt = (e) => {
    const amt = e.target.value;
    const pct = totals.subtotal > 0 && amt !== "" ? fix((num(amt) / totals.subtotal) * 100) : "";
    onChange({ ...head, discount_amount: amt, discount_percent: pct });
  };
  const setTaxPct = (e) => {
    const pct = e.target.value;
    const amt = totals.afterDiscount > 0 && pct !== "" ? fix((num(pct) * totals.afterDiscount) / 100) : "";
    onChange({ ...head, tax_percent: pct, tax_amount: amt });
  };
  const setTaxAmt = (e) => {
    const amt = e.target.value;
    const pct = totals.afterDiscount > 0 && amt !== "" ? fix((num(amt) / totals.afterDiscount) * 100) : "";
    onChange({ ...head, tax_amount: amt, tax_percent: pct });
  };

  const ro = (v, testid) => (
    <div dir="ltr" data-testid={testid}
         className="num flex h-12 items-center rounded-2xl bg-muted/40 px-4 text-sm font-bold shadow-neu-in">
      {currency} {fmtMoney(v)}
    </div>
  );

  return (
    <div className="grid gap-3 rounded-2xl p-4 shadow-neu-in" data-testid="purchase-totals">
      <label className="grid gap-1">
        <span className="text-[11px] font-bold text-muted-foreground">{t("purchases.grandSubtotal")}</span>
        {ro(totals.subtotal, "totals-subtotal")}
      </label>
      <div className="grid gap-3 sm:grid-cols-3">
        <label className="grid gap-1">
          <span className="text-[11px] font-bold text-muted-foreground">{t("purchases.discountPct")}</span>
          <NeuInput data-testid="purchase-discount-pct" dir="ltr" placeholder="0"
                    value={head.discount_percent || ""} onChange={setDiscPct} />
        </label>
        <label className="grid gap-1">
          <span className="text-[11px] font-bold text-muted-foreground">{t("purchases.discountAmt")}</span>
          <NeuInput data-testid="purchase-discount-amt" dir="ltr" placeholder="0"
                    value={head.discount_amount || ""} onChange={setDiscAmt} />
        </label>
        <label className="grid gap-1">
          <span className="text-[11px] font-bold text-muted-foreground">{t("purchases.afterDiscount")}</span>
          {ro(totals.afterDiscount, "totals-after-discount")}
        </label>
      </div>
      <div className="grid gap-3 sm:grid-cols-3">
        <label className="grid gap-1">
          <span className="text-[11px] font-bold text-muted-foreground">{t("purchases.taxPct")}</span>
          <NeuInput data-testid="purchase-tax-pct" dir="ltr" placeholder="0"
                    value={head.tax_percent ?? 0} onChange={setTaxPct} />
        </label>
        <label className="grid gap-1">
          <span className="text-[11px] font-bold text-muted-foreground">{t("purchases.taxAmount")}</span>
          <NeuInput data-testid="purchase-tax-amt" dir="ltr" placeholder="0"
                    value={head.tax_amount || ""} onChange={setTaxAmt} />
        </label>
        <label className="grid gap-1">
          <span className="text-[11px] font-bold text-muted-foreground">{t("purchases.grandTotal")}</span>
          {ro(totals.grand, "totals-grand")}
        </label>
      </div>
      {overridden ? (
        <div data-testid="tax-override-warn"
             className="flex items-center gap-2 rounded-xl bg-amber-100 px-3 py-2 text-[11px] font-bold text-amber-900 dark:bg-amber-900/30 dark:text-amber-100">
          <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
          <span>{t("purchases.taxOverride", { current: num(head.tax_percent), def: num(defPct) })}</span>
        </div>
      ) : null}
    </div>
  );
};
